import { render, staticRenderFns } from "./ThemesList.vue?vue&type=template&id=ed563b9c"
import script from "./ThemesList.vue?vue&type=script&lang=js"
export * from "./ThemesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports